// Content data extracted from PDF design
export const content = {
  hero: {
    headline: "Your trusted partner in home financing",
    subcopy: "We provide expert mortgage solutions for buying, refinancing, or reverse mortgages, all tailored to fit your unique financial goals and needs.",
    cta: "Get your rate",
    trustLine: "We help to save more than $372M for the people to buy their first house with us."
  },
  
  savingsColumns: [
    {
      percentage: "1.25%",
      title: "Can save to Buy new home with us",
      description: "Save more when you buy your new home with us. We secure the best mortgage rates for your budget. Experience a smooth, stress-free homebuying process with personalized support."
    },
    {
      percentage: "1.75%",
      title: "Can save to Refinance your home with us", 
      description: "Refinance and save with our highly competitive rates. Lower your monthly payments or access your home's equity with ease. We make refinancing quick, simple, and efficient for long-term savings."
    },
    {
      percentage: "2.25%",
      title: "Can save when apply for Reverse mortgage",
      description: "Unlock your home's value and save for a more secure retirement. Get the best reverse mortgage rates, tailored specifically to your financial goals. Enjoy financial freedom without monthly payments."
    },
    {
      percentage: null,
      title: "We will find great rate for you",
      description: null,
      cta: "Get your rate"
    }
  ],

  mortgageTypes: {
    headline: "Mortgage types",
    description: "Looking to purchase a new home? Refinance for better rates? Exploring reverse mortgage options? We have the perfect solution for you. Our mortgage services are designed to fit your financial needs and goals. Explore our tailored options to find the mortgage that works best for your situation.",
    cards: [
      {
        icon: "🏠",
        title: "Purchase New Home",
        description: "Get expert assistance to secure the best mortgage rates and terms, guiding you through the entire home-buying process.",
        bestFor: ["First time buyer", "Second home", "Investing"],
        cta: "Get your rate"
      },
      {
        icon: "🔄",
        title: "Refinance Home", 
        description: "Refinance your existing mortgage to lower interest rates, adjust loan terms, or access your home's equity quickly.",
        bestFor: ["Get lower APR", "Lower monthly payment", "Investing"],
        cta: "Get your rate"
      },
      {
        icon: "📊",
        title: "Reverse Mortgage",
        description: "A reverse mortgage allows homeowners 62+ to convert home equity into cash while staying in their property.",
        bestFor: ["Access home equity", "No monthly payments", "Supplement retirement income"],
        cta: "Get your rate"
      }
    ]
  },

  homeownership: {
    headline: "We help to own home faster and more accessible",
    description: "With our expert guidance and competitive mortgage options, we make homeownership faster and more accessible. Whether you're a first-time buyer or looking to upgrade, we simplify the process, securing the best rates to help you own your dream home sooner.",
    benefits: [
      "We have access to best lenders",
      "Wide variety of loan mortgages", 
      "Fast process - just one day"
    ],
    cta: "Get your rate",
    contactCta: "Contact us"
  },

  benefits: {
    headline: "Why Choose Mortgage+",
    bullets: [
      "Personalized service with dedicated loan officers",
      "Competitive rates and flexible terms",
      "Streamlined process with quick approvals"
    ]
  },

  stats: {
    years: "17+",
    clients: "128+", 
    satisfaction: "96%"
  },

  testimonials: [
    {
      name: "Elena Tuttle",
      city: "Tustin",
      quote: "The team made our first home purchase seamless and stress-free. Highly recommend!"
    },
    {
      name: "Dan May", 
      city: "Costa Mesa",
      quote: "Refinanced our home and saved $400/month. Excellent service throughout."
    },
    {
      name: "Agent Ivy",
      city: "Irvine", 
      quote: "As a real estate agent, I trust Mortgage+ with all my clients' financing needs."
    }
  ],

  recentTransactions: [
    {
      type: "Single Family Home",
      location: "Beverly Hills, CA",
      amount: "$2,400,000",
      term: "30 Yrs fixed"
    },
    {
      type: "Single Family Home",
      location: "Rolling Hills Estates, CA", 
      amount: "$1,500,000",
      term: "30 Yrs fixed"
    },
    {
      type: "Single Family Home",
      location: "Palos Verdes, CA",
      amount: "$2,100,000", 
      term: "30 Yrs fixed"
    },
    {
      type: "Single Family Home",
      location: "Beverly Hills, CA",
      amount: "$1,500,000",
      term: "30 Yrs fixed"
    },
    {
      type: "Single Family Home",
      location: "Rolling Hills Estates, CA",
      amount: "$2,400,000",
      term: "12 months"
    },
    {
      type: "Single Family Home",
      location: "Manhattan Beach, CA",
      amount: "$600,000",
      term: "30 Yrs fixed"
    }
  ],

  faq: [
    {
      question: "What services do you offer?",
      answer: "We specialize in helping clients buy homes, refinance existing mortgages, and access reverse mortgage options, providing personalized solutions."
    },
    {
      question: "How do I get started with your services?",
      answer: "Simply fill out a contact form, call, or use an online application. A team will guide the user."
    },
    {
      question: "Why should I choose your company?",
      answer: "We offer expert guidance, competitive rates, and a personalized approach. Clients consistently rate us highly for excellent service."
    },
    {
      question: "How long does the mortgage process take?",
      answer: "Varies, but typically 30-45 days from application to closing, depending on the mortgage type and financial profile."
    },
    {
      question: "What credit score do I need to qualify?",
      answer: "Most loan programs require a credit score of 620 or higher, but we have options for various credit situations."
    }
  ],

  footer: {
    address: "24445 Hawthorne Blvd, 201 Torrance, CA 90505",
    licensing: "Valentino Adams NMLS ID: #1630597 California Department of Real Estate License # 02026623",
    socialMedia: ["LinkedIn", "Instagram", "Facebook", "Twitter"],
    headline: "We will find great rate",
    description: "We compare mortgage options to find the best rate tailored for your. Save more with our expert guidance.",
    contactCta: "Contact us",
    rateCta: "Get your rate →",
    mortgageLinks: ["Purchase", "Refinance", "Reverse Mortgage"],
    rateLinks: ["Purchase Rate", "Refinance Rate", "Reverse Mortgage Rate"],
    supportLinks: ["Contact us", "FAQ"],
    legal: ["Privacy Policy", "Terms of Service", "Cookie Settings"],
    copyright: "© 2024 Mortgage+. All rights reserved."
  }
};